import styled from 'styled-components';

export const PseudoCalendarContainer = styled.div`
    display: flex;
    gap: 0.5rem;
    padding: 0.75rem 1rem;

    border: 1px solid var(--Neutral-300, #d4d4d8);
    background: ${props => props.theme.colors['neutral-0']};
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);

    border-radius: 1.875rem;

    align-self: stretch;
    align-items: center;

    svg {
        width: 1.25rem;
        height: 1.25rem;
        color: ${props => props.theme.colors['neutral-500']};
    }

    color: var(--Neutral-950, #09090b);
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;

    .actions-wrapper {
        display: flex;
        gap: 0.5rem;
        margin-left: auto;

        button {
            &:hover {
                color: ${props => props.theme.colors['neutral-950']};
            }
        }
    }
`;
